export const services = [
    {
      id: 1,
      title: "Concrete Driveways",
      description:
        "Our concrete driveways are strong, durable, and require little maintenance once installed.",
      image: "./img/card_1_driveways.jpg",
      link: "/gallery",
    },
    {
      id: 2,
      title: "Pool Decks, Porches, & Patios",
      description:
        "Give your pool, porch, or patio area a beautiful and lasting finish with a custom concrete installation.",
      image: "./img/card_2_patios.jpg",
      link: "/gallery",
    },
    {
      id: 3,
      title: "Sidewalks & Walkways",
      description:
        "Installing a custom sidewalk or walkway to your home or business is the perfect way to add curb appeal.",
      image: "./img/card_3_sidewalks.jpg",
      link: "/gallery",
    },
    {
      id: 4,
      title: "Garage Slabs & Pads",
      description:
        "Garage slabs and pads are universal and a great way to add a functional extension to your home or business.",
      image: "./img/card_4_pads.jpg",
      link: "/gallery",
    },
    {
      id: 5,
      title: "Custom Concrete Work",
      description:
        "Our crew has mastered the art of custom concrete work—providing our customers with endless options.",
      image: "./img/card_5_custom.jpg",
      link: "/gallery",
    },
    {
      id: 6,
      title: "Demolition & More!",
      description:
        "At H&W Concrete we deliver so much more value to our customers. Call us today for a free consultation!",
      image: "./img/card_6_demolition.jpg",
      link: "/gallery",
    },
  ];